<div class="container-fluid">
  <section class="hero-section">
    <div class="hero-container">
      <ngx-slick-carousel class="carousel"
                          #slickModal="slick-carousel"
                          [config]="slideConfig">
        <div ngxSlickItem *ngFor="let slide of slides" class="slide">
          <img [src]="apiURL + slide.photoPath1"
               [alt]="slide.name"
               class="slide-img" />
        </div>
      </ngx-slick-carousel>


    </div>
  </section>
</div>
